//Core modules
import React,{Fragment} from "react";

//Internel
import requestApi from "../../../services/requestApi.service";
import { Col, Row} from "react-bootstrap";
import ListBox from "../../../Common/ListBox";
import {showToast,handleErrorResponse,parseJSON,getSessionValue} from "../../../Common/Appcommon";
import TableList from "../../../Common/TableList";
import FieldsMapping from "../../../Common/FieldsMapping";
import { CloudUpload } from "@mui/icons-material";
import CloudTelephonyDetails from "../../../Common/cloudtelephonydetails.json";

class CloudTelephonyItems extends React.Component{

    constructor(props) {
        super(props);
        this.state={
            CloudTelephonys : [],
            isConfigView : false,
            adForms : {},
            adFormInfo : {},
            showMapping : false,
            webhookformname : '',
            listfieldsname : [['Appid','Provider','Edit'],['1','2','0']],
            keysArray : [],
            leadStatus : '',
            ctcproviderdel : {},
            provider : '',
            userconfiguration: [],
            data :[],
        }
    }

    componentDidMount = () => {
        this.getCloudTelephony();
    }

     getFormsList = async (providername) => {
            this.setState({
               webhookformname : CloudTelephonyDetails[providername]['webhookurl'],
               keysArray : CloudTelephonyDetails[providername]['mappingfields'],
               //adForms : response.data[2],
               ctcproviderdel : CloudTelephonyDetails[providername]['apikeydetails'],
               provider:providername,
               adFormInfo : [providername],
               userconfiguration:CloudTelephonyDetails[providername]['userconfiguration'] !== undefined ? CloudTelephonyDetails[providername]['userconfiguration'] : "",
               data : CloudTelephonyDetails[providername]['data']
            });
    }

    getLeadStatus = async (providername) => {
        let params = {
            "ENTITY" : "CLOUDTELEPHONYLEADSPROCESS",
            "OPERATION" : 'GET_LEADCREATION_STATUS',
            "PROVIDER" : providername,
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            this.setState({
                leadStatus : response.data
            })
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    getCloudTelephony = async () => {
        // let params = {
        //     "ENTITY": "WHATSAPPPROCESS",
        //     "OPERATION" : "GETCLOUDTELEPHONY",
        // }
        // let response = await requestApi.processServerRequest(params, "web");
        // let result = response.data !== undefined && response.data !== null  ? response.data : '';
        let CloudDetails = CloudTelephonyDetails;
        let CloudTelephony = [];
        Object.keys(CloudDetails).map((item, i) => {
            CloudTelephony.push(CloudDetails[item]);           
            if(CloudDetails[item]['isintegrated']){
                 CloudTelephony[i]['btnText'] = "Create Your Mapping" ;
                } else { 
                    CloudTelephony[i]['btnText'] = "Coming Soon!";
                }
            
            });
        this.setState({
            CloudTelephonys : CloudTelephony
        })
    }

    onExploreAction = async (CloudTelephony) => {
        this.getFormsList(CloudTelephony.name);
        await this.getLeadStatus(CloudTelephony.name);
        await this.setState({
            isConfigView : true
        })
    }

     onBackAction = async(e) => {
        this.setState({
            isConfigView : false
        })
        window.location = "#/settings/cloudtelephony";
    }

    render(){
        let {isConfigView} = this.state;
        let {adForms} = this.state;
        let {adFormInfo} = this.state;
        let {showMapping} = this.state;
        let {webhookformname} = this.state;
        let {listfieldsname} = this.state;
        let {keysArray} = this.state;
        let {leadStatus} = this.state;
        let {ctcproviderdel} = this.state;
        let {provider} = this.state;
        let {userconfiguration} = this.state;
        let {data} = this.state;
        return(
            <>
                <Fragment>
                {!isConfigView ?
                    <div className={'setup-integration'}>
                        <div className={"col-md-12 integration-container"}>
                            <Row>
                                {
                                    this.state.CloudTelephonys != undefined &&
                                    this.state.CloudTelephonys.map((CloudTelephony)=>{
                                        return (
                                            <ListBox onExploreAction={e => this.onExploreAction(CloudTelephony)} ListData={CloudTelephony}/>
                                        );
                                    })
                                }
                            </Row>
                        </div>
                    </div>
                    :
                    <>
                <div className={'setup-integration'}>
                   <div className={"col-md-12 integration-container"}>
                    {!showMapping &&
                        <TableList
                        
                            onBackAction={this.onBackAction}
                            adForms={adForms}
                            renderElements={this.renderElements}
                            webhookform={webhookformname}
                            titlename={"Cloud Telephony Mapping"}
                            listfieldsname={listfieldsname}
                            screen ={"CloudTelephony"}
                            providerDetails ={ctcproviderdel}
                            provider = {provider}
                            userconfiguration={userconfiguration}
                            data={data}
                         />                  
                    }
                    {!showMapping &&
                        <FieldsMapping
                            showMapping={showMapping}
                            formInfo={adFormInfo}
                            onBackAction={this.hideEditScreen}
                            screen ={"CloudTelephony"}
                            mappingCol ={keysArray}
                            leadstatus = {leadStatus}
                            provider = {provider}
                        />       
                     
                    }
                  </div>
                </div>
                    </>
                    
                }
                </Fragment>               
            </>           
        )
    }
}

export default CloudTelephonyItems;